"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRegistrationCreators = void 0;
/**
 * @example const { createRegisterableComponent, createRegisterableComposition } = getRegistrationCreators<MyServices>()
 */
function getRegistrationCreators() {
    return {
        /** Helper function to create the registration (to infer types) */
        createRegisterableComponent(type, render) {
            return { type, render };
        },
        /** Creates a registerable composition, it is a two step process due to TypeScript limitations
         *
         * First createRegisterableComponent<'main'|'sidebar'>() creates a registration function
         * for a composition with two content areas, main and sidebar.
         * Second call that registration function to create the registration.
         */
        createRegisterableComposition() {
            return (type, render, componentProps) => ({
                type,
                render,
                componentProps,
            });
        },
    };
}
exports.getRegistrationCreators = getRegistrationCreators;
//# sourceMappingURL=get-registration-creators.js.map